// OneSignal（店舗スタッフ向け Web Push）の設定。nuxt.config.js（Node）と plugins/onesignal.client.js（ブラウザ）の両方から読む。
//
// OneSignal 側の Web Push 設定は https://cp.gyms.jp だけを許している。ほかのホスト（staging の gyms-cmp-stg.web.app・
// dev の 127.0.0.1 など）で init すると SDK が「This web push config can only be used on https://cp.gyms.jp」を
// 未処理の Promise 例外として投げ、staging の読み取りスモークが全画面で赤になっていた（2026-10-25）。
// そこで、許可ホスト以外では init しない（staging・dev では OneSignal を動かさない）。本番（cp.gyms.jp）は今までどおり。
// テスト: __tests__/config/oneSignal.spec.js・__tests__/plugins/onesignal.spec.js
// ブラウザ側の bundle にも入るので Node の path などは使わない

// OneSignal の管理画面で許可しているホスト（Site URL）。増やすときは OneSignal 側の設定と一緒に
const ONESIGNAL_ALLOWED_HOSTS = ['cp.gyms.jp']

// @nuxtjs/onesignal のプラグインの代わりに入れるプラグイン
const ONESIGNAL_PLUGIN_SRC = '~/plugins/onesignal.client.js'

const isOneSignalAllowedHost = hostname => {
  if (typeof hostname !== 'string' || !hostname) {
    return false
  }
  const host = hostname.toLowerCase().replace(/\.$/, '')
  return ONESIGNAL_ALLOWED_HOSTS.includes(host)
}

// 今までの nuxt.config.js と同じ: development だけ dev 用のアプリ、それ以外（production・staging・release）は本番のアプリ
const oneSignalAppId = nodeEnv =>
  nodeEnv === 'development'
    ? '3b9c7e69-d214-423e-8a66-6c5dae77acb6'
    : 'ebecab36-80e1-46cd-8a0e-009728069a75'

const oneSignalInitOptions = appId => ({
  appId,
  allowLocalhostAsSecureOrigin: true,
  welcomeNotification: {
    disable: true
  }
})

// nuxt.config.js の extendPlugins から呼ぶ。@nuxtjs/onesignal が addPlugin した <buildDir>/onesignal.js
// （ホストを見ずに init する templates/plugin.js）を、同じ位置で ONESIGNAL_PLUGIN_SRC に差し替える。
// SDK の読み込み（head の script）・Service Worker・manifest はモジュールのまま変えない。
const replaceOneSignalPlugin = (plugins, buildDir) => {
  const norm = s => (typeof s === 'string' ? s.replace(/\\/g, '/') : s)
  const moduleSrc = `${norm(buildDir).replace(/\/+$/, '')}/onesignal.js`
  const srcOf = p => norm(typeof p === 'string' ? p : p && p.src)
  const index = plugins.findIndex(p => srcOf(p) === moduleSrc)
  if (index === -1) {
    // dev の再ビルドでは差し替え済みの一覧が来る
    if (plugins.some(p => srcOf(p) === ONESIGNAL_PLUGIN_SRC)) {
      return plugins
    }
    throw new Error(
      `@nuxtjs/onesignal のプラグイン（${moduleSrc}）が見つかりません。モジュールの更新で場所が変わったら config/oneSignal.js を直してください`
    )
  }
  const result = plugins.slice()
  result[index] = { src: ONESIGNAL_PLUGIN_SRC, mode: 'client' }
  return result
}

module.exports = {
  ONESIGNAL_ALLOWED_HOSTS,
  ONESIGNAL_PLUGIN_SRC,
  isOneSignalAllowedHost,
  oneSignalAppId,
  oneSignalInitOptions,
  replaceOneSignalPlugin
}
